// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"90f8bbf4","143":"86b8e1c6","144":"ae2a4af1","494":"8083199f","533":"02065213","651":"fe457c64","690":"038f1911","852":"928e4d59","940":"b93e0e6e"}[chunkId] + ".chunk.js";
};